<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      autocomplete="off"
      class="form-control"
      @change="emit"
      @input="emit"
      @blur="blur"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <div v-if="!isView">
      <a class="transport-owner-helpers" @click="changeUserPosition('Водитель')">Водитель</a>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '@/common/mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportUserPositionInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    transportInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Должность'
    },

    inputName: {
      default: 'user_position'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      return `form-visitor-status-${this.visitorIndex}`
    }
  },

  methods: {
    blur($event) {
      this.inputValue = this.upperCaseFirst($event.target.value)
    },

    changeUserPosition(position) {
      this.inputValue = this.upperCaseFirst(this.upperCaseFirst(position))
    },

    upperCaseFirst(str) {
      return str.charAt(0).toUpperCase() + str.substring(1)
    }
  }
}
</script>
